export default __webpack_public_path__ + "static/media/podcasts.41c1d55c.png";